var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('ctrl-search',{attrs:{"results":_vm.results,"loading":_vm.isLoading,"placeholder":_vm.placeholder,"cssClass":_vm.searchBoxClass},on:{"change":_vm.search,"result":_vm.onResult,"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }